export default {
  slug: "ai-assistant",
  code: "AS",
  label: "AI Assistant",
  logoFamily: "as",
};
